import Component from '../classes/Component';
import { $dom } from '../helpers/dom';
import { $events } from '../helpers/events';
import { isElement } from '../helpers/_utilities';
import variables from '../variables';

const { get, getParent, addClass, removeClass, remove, attr } = $dom;

const formId = 'js-feedback-form';
const buttonSubmitSelector = `#${formId} button[type="submit"]`;
const inputPhoneSelector = `#${formId} input[name="phone"]`;

export function feedbackForm() {

  const Page = this;
  const loader = $dom.createElement('div', {
    class: "spinner-border spinner-border-sm text-primary",
  })

  function validatePhone(t) {

    let target;

    if(t instanceof Event) {
      target = t.target;
    } else if (isElement(t)) {
      target = t;
    }

    if (Boolean(target)) {
      const inputIsValid = target.value.length >= 18;

      const button = get(buttonSubmitSelector);

      if (!isElement(button)) return

      button.disabled = !inputIsValid;
    }
  }

  function setFormState(action) {    
    const input = get(inputPhoneSelector);
    const button = get(buttonSubmitSelector);

    const inputHolder = getParent(input);

    if (!isElement(input) || !isElement(button)) return;

    switch(action) {
      case 'default':
        console.log('State: default');
        button.disabled = input.disabled = false;

        if (isElement(inputHolder)) {
          remove(loader)

          removeClass(inputHolder, variables.classNames.lazyLoading);
        }
        break;
      case 'loading':
        console.log('State: loading');
        button.disabled = input.disabled = true; 

        if (isElement(inputHolder)) {
          inputHolder.appendChild(loader);

          addClass(inputHolder, variables.classNames.lazyLoading);
        }

        break;
    }
  }

  function handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const button = get(buttonSubmitSelector);
    const url = attr(event.target, "action");
    const method = attr(event.target, "method");

    setFormState('loading');

    fetch(url, {
      method: method,
      body: formData
    })
      .then(response => response.json())
      .then(result => {

        switch (result.code) {
          case 'success':
            Page.toast.show('Спасибо, ваше сообщение отправлено', 'success');
            break;
          case 'error':
            Page.toast.show(result.errors, 'danger');
            break;
        }

        const input = get(inputPhoneSelector);   

        input.value = '';

        button.disabled = false;

      })
      .finally(setFormState.bind(null, 'default'));
  }

  return new Component({
    name: 'feedbackForm',
    requiredSelector: '#' + formId,
    onInit() {

      validatePhone(get(inputPhoneSelector))

      $events.delegate
        .on('submit', '#' + formId, handleFormSubmit)
        .on('input', inputPhoneSelector, validatePhone)
    },
    onDestroy() {
      $events.delegate
        .off('submit', '#' + formId, handleFormSubmit)
        .off('input', inputPhoneSelector, validatePhone)
    }
  })
}